import React, { createContext, ReactNode, useContext } from 'react'

import type { AssetVizTheme } from '@asset-viz/types/providers'
import { defaultTheme } from './defaultTheme'

const AssetVizThemeContext = createContext<AssetVizTheme | undefined>(undefined)

interface AssetVizThemeProviderProps {
  theme: AssetVizTheme
  children: ReactNode
}

export const AssetVizThemeProvider: React.FC<AssetVizThemeProviderProps> = ({
  theme,
  children,
}) => {
  return (
    <AssetVizThemeContext.Provider value={theme}>
      {children}
    </AssetVizThemeContext.Provider>
  )
}

export function useAssetVizTheme(): AssetVizTheme {
  const theme = useContext(AssetVizThemeContext)
  return theme ?? defaultTheme
}
